import {Dispatcher} from "../../../stem-core/src/base/Dispatcher.js";
import {NOOP_FUNCTION} from "../../../stem-core/src/base/Utils.js";


export class AddressController extends Dispatcher {
    addressSectionState = null;
    selectedAddress = null;
    continueLabel = ""; // TODO @branch WTF is this?
    onSelectSuccess = NOOP_FUNCTION; // TODO @branch just use async something
    onSelectCancel = NOOP_FUNCTION;

    constructor(options={}) {
        super(options);
        this.update(options);
    }

    update(props) {
        Object.assign(this, props);
        this.dispatch();
    }
}
